import { autoinject } from 'aurelia-framework';
import { CustomerSettings } from '../classes/customer-settings';
import { InstrumentTypeViewModel, VouchersClient } from '@dynamik/common/clients/transaction-clients';
import { DocumentsClient } from '@dynamik/common/clients/inboxv2-clients';

export interface ProcessUpvVievModel {
  DocumentId?: number;
  RowId?: number;
}

@autoinject
export class InboxService {
  constructor(private customerSettings: CustomerSettings, private documentsClient: DocumentsClient, private vouchersClient: VouchersClient) { }

  instrumentTypes: InstrumentTypeViewModel[];

  async openDocument(documentId: string) {
    window.open(URL.createObjectURL((await this.documentsClient.file(this.customerSettings.selectedCustomer.companyId, documentId)).data), '_blank');
  }

  async downloadDocument(documentId: string) {
    const response = await this.documentsClient.file(this.customerSettings.selectedCustomer.companyId, documentId);
    this.saveBlob(response.data, response.fileName ?? documentId);
  }

  async openVoucherDocument(voucherId: string) {
    window.open(URL.createObjectURL((await this.vouchersClient.document(this.customerSettings.selectedCustomer.companyId, voucherId)).data), '_blank');
  }

  async downloadVoucherDocument(voucherId: string) {
    const response = await this.vouchersClient.document(this.customerSettings.selectedCustomer.companyId, voucherId);
    this.saveBlob(response.data, response.fileName ?? voucherId);
  }

  async getDocumentObjectUrl(documentId: string) {
    return URL.createObjectURL((await this.documentsClient.file(this.customerSettings.selectedCustomer.companyId, documentId)).data);
  }

  // Downloads go through the NSwag clients so the request carries the bearer
  // auth header. A plain window.open() to the API URL is unauthenticated, so the
  // gateway serves the SPA fallback and Aurelia fails with "Route not found".
  private saveBlob(blob: Blob, fileName: string) {
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

  async getInstrumentTypes() {
    return this.instrumentTypes;
  }
}
